import React from 'react'
import { cn } from '../../utils/cn'

/** Marketing page hero — kicker + display title + lede. */
export function PageHero({ kicker, title, lede, children, className }) {
  return (
    <section className={cn('relative overflow-hidden', className)}>
      {/* soft accent wash */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-accent-50/60 to-transparent" />
      <div className="absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-accent-200 to-transparent" />
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-8 pt-16 pb-10 sm:pt-20 sm:pb-12">
        {kicker && <div className="kicker mb-3 text-accent-600">{kicker}</div>}
        <h1 className="font-display font-semibold text-ink-900 tracking-tight text-[34px] sm:text-[44px] leading-[1.05] max-w-3xl">
          {title}
        </h1>
        {lede && <p className="mt-5 text-lg text-ink-500 leading-7 max-w-2xl">{lede}</p>}
        {children && <div className="mt-7">{children}</div>}
      </div>
    </section>
  )
}

/** A content section with an optional heading. */
export function Section({ title, sub, children, className, tone }) {
  return (
    <section className={cn(tone === 'quiet' && 'bg-ink-25/70 border-y border-ink-100', className)}>
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        {title && (
          <div className="mb-8 max-w-2xl">
            <h2 className="font-display font-semibold text-ink-900 text-2xl sm:text-3xl tracking-tight">{title}</h2>
            {sub && <p className="mt-3 text-ink-500 leading-7">{sub}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  )
}

/** Long-form prose block for legal / about copy. */
export function Prose({ children, className }) {
  return (
    <div className={cn('mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16', className)}>
      <div className="space-y-6 text-[15px] leading-7 text-ink-600 [&_h2]:font-display [&_h2]:font-semibold [&_h2]:text-ink-900 [&_h2]:text-xl [&_h2]:tracking-tight [&_h2]:mt-10 [&_h2]:mb-2 [&_strong]:text-ink-800 [&_a]:text-accent-700 [&_a]:font-medium [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5">
        {children}
      </div>
    </div>
  )
}
